import React, { useEffect } from "react";
import { AiOutlineSafety } from "react-icons/ai";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import useBasketManager from "../../SaleMovie/CinemaHall/hooks/useBasketManager";
import "./style.scss";
import { PaymentLogos } from "../../../../features/PaymentLogo";
import { useTranslation } from "react-i18next";

interface IProps {
  eCardPaymnet: Function;
  handleSetPayment: (type: string) => void;
  alert: string;
}

const EcardSummary: React.FC<IProps> = ({ eCardPaymnet, handleSetPayment, alert }: IProps) => {
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const { t } = useTranslation();
  const { getBasket, total, totalListPrice } = useBasketManager();
  useEffect(() => {
    setTimeout(() => {
      getBasket();
    }, 400);
  }, []);

  return (
    <React.Fragment>
      <div className="basket-summary">
        <h3>{t("podsumowanie_zamowienia")}</h3>

        <div className="summary-line flex-between-center">
          <span>{t("do_zaplaty")}: </span>
          <b>
            {total.toFixed(2)} {t("zl")}
          </b>
        </div>

        <div className="summary-line promition-line flex-between-center">
          <span>{t("oszczedasz")}:</span>
          <b>
            {(totalListPrice - total).toFixed(2)}
            {t("zl")}
          </b>
        </div>

        {alert.length > 2 && <div className="alert alert-red">{alert}</div>}

        <div className="ecard-summary-buttons">
          <div className="button button-fill-main big full-button move-up" onClick={() => eCardPaymnet()}>
            {t("potwierdz_platnosc_ekarta")}
            <AiOutlineSafety className="icon" />
          </div>
          <p className="or extra-margin">{t("lub")}</p>
          <button onClick={() => handleSetPayment("online")} className="button button-outline-second big full-button">
            {t("wroc_do_platnosci_internetowej")}
          </button>
        </div>

        <PaymentLogos />
      </div>
    </React.Fragment>
  );
};

export default EcardSummary;
